export default __webpack_public_path__ + "static/media/0xa863246658dea34111c3c1dcedb2cfd5d6067334.1affbf19.webp";